import { APPOINTMENT_STATUSES } from 'constants/appointments';

import { EVENT_COLORS } from 'pages/Calendar/constants';

export const getStatusColor = (status: number) => {
  switch (status) {
    case APPOINTMENT_STATUSES.awaiting_confirmation:
      return EVENT_COLORS[5];
    case APPOINTMENT_STATUSES.approved:
      return EVENT_COLORS[6];
    case APPOINTMENT_STATUSES.started:
      return EVENT_COLORS[4];
    case APPOINTMENT_STATUSES.completed:
      return EVENT_COLORS[7];
    case APPOINTMENT_STATUSES.canceled:
    case APPOINTMENT_STATUSES.rejected:
      return EVENT_COLORS[2];
    case APPOINTMENT_STATUSES.finished:
      return EVENT_COLORS[8];
  }
};

interface Element {
  id: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export function groupByStatus<T extends Element>(
  array: T[],
  key: string
): Record<string, T[]> {
  const grouped: Record<string, T[]> = {};

  array.forEach(element => {
    const status = element[key];

    if (!grouped[status]) {
      grouped[status] = [];
    }

    grouped[status].push(element);
  });

  return grouped;
}
